(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll(".collection-tabs-filter").forEach(function (container) {
      var buttons = container.querySelectorAll(".collection-tabs-filter__btn");
      var panels = container.querySelectorAll(".collection-tabs-filter__panel");

      buttons.forEach(function (btn) {
        btn.addEventListener("click", function () {
          var targetId = btn.getAttribute("data-target");

          buttons.forEach(function (b) {
            b.classList.remove("collection-tabs-filter__btn--active");
            b.setAttribute("aria-selected", "false");
          });

          panels.forEach(function (panel) {
            panel.classList.remove("collection-tabs-filter__panel--active");
            panel.hidden = true;
          });

          btn.classList.add("collection-tabs-filter__btn--active");
          btn.setAttribute("aria-selected", "true");

          var activePanel = document.getElementById(targetId);
          if (activePanel) {
            activePanel.classList.add("collection-tabs-filter__panel--active");
            activePanel.hidden = false;
          }
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-bundle-builder"] && !Shopify.designMode) return;
  try {
    
class BundleBuilder {
  constructor(el) {
    this.el = el;
    this.currency = el.dataset.currency || "NOK";
    this.groups = new Map();
    this.ctaEl = el.querySelector("[data-bundle-cta]");
    this.totalEl = el.querySelector("[data-bundle-total]");
    this.errEl = el.querySelector("[data-bundle-err]");
    this.hintEl = el.querySelector("[data-bundle-hint]");
    this.totalGroups = parseInt(el.querySelector("[data-total-groups]")?.dataset.totalGroups || "0", 10);

    el.querySelectorAll("[data-group][data-required]").forEach(g => {
      const id = g.dataset.group;
      const required = parseInt(g.dataset.required, 10) || 1;
      this.groups.set(id, { required, selected: [] });
    });

    el.querySelectorAll(".bundle-builder__card").forEach(btn => {
      btn.addEventListener("click", () => this.toggle(btn));
    });

    this.ctaEl?.addEventListener("click", () => this.addToCart());
  }

  toggle(btn) {
    const { group: gid, variant, name, price } = btn.dataset;
    const g = this.groups.get(gid);
    if (!g) return;

    const idx = g.selected.findIndex(s => s.variant === variant);

    if (idx > -1) {
      g.selected.splice(idx, 1);
      btn.setAttribute("aria-pressed", "false");
      btn.closest("[role=option]")?.setAttribute("aria-selected", "false");
    } else {
      if (g.required === 1) {
        g.selected.forEach(s => {
          const prev = this.el.querySelector(".bundle-builder__card[data-group='" + gid + "'][data-variant='" + s.variant + "']");
          prev?.setAttribute("aria-pressed", "false");
          prev?.closest("[role=option]")?.setAttribute("aria-selected", "false");
        });
        g.selected = [];
      } else if (g.selected.length >= g.required) {
        return;
      }
      g.selected.push({ variant, name, price: parseInt(price, 10) });
      btn.setAttribute("aria-pressed", "true");
      btn.closest("[role=option]")?.setAttribute("aria-selected", "true");
    }

    this.refresh(gid, g);
  }

  refresh(gid, g) {
    const badge = this.el.querySelector("[data-badge='" + gid + "']");
    if (badge) {
      badge.textContent = g.selected.length + " / " + g.required;
      badge.classList.toggle("bundle-builder__step-badge--complete", g.selected.length >= g.required);
    }

    this.el.querySelector("[data-group='" + gid + "']")
      ?.classList.toggle("bundle-builder__step--complete", g.selected.length >= g.required);

    const slotsEl = this.el.querySelector("[data-summary-slots='" + gid + "']");
    if (slotsEl) {
      slotsEl.querySelectorAll(".bundle-builder__slot").forEach((slot, i) => {
        const item = g.selected[i];
        if (item) {
          slot.className = "bundle-builder__slot bundle-builder__slot--filled";
          slot.innerHTML = "<span class='bundle-builder__slot-name'>" + item.name + "</span><span class='bundle-builder__slot-price'>" + this.money(item.price) + "</span>";
        } else {
          slot.className = "bundle-builder__slot bundle-builder__slot--empty";
          slot.innerHTML = "<span class='bundle-builder__slot-name'>—</span>";
        }
      });
    }

    let subtotal = 0;
    this.groups.forEach(gr => gr.selected.forEach(s => { subtotal += s.price; }));

    const discountPct = parseInt(this.el.dataset.discountPercent || "0", 10);
    const total = discountPct > 0 ? Math.round(subtotal * (1 - discountPct / 100)) : subtotal;
    const savings = subtotal - total;

    const subtotalEl = this.el.querySelector("[data-bundle-subtotal]");
    const savingsEl = this.el.querySelector("[data-bundle-savings]");
    if (subtotalEl) subtotalEl.textContent = subtotal > 0 ? this.money(subtotal) : "—";
    if (savingsEl) savingsEl.textContent = savings > 0 ? "-" + this.money(savings) : "—";
    if (this.totalEl) this.totalEl.textContent = total > 0 ? this.money(total) : "—";

    const complete = this.groups.size > 0 && [...this.groups.values()].every(gr => gr.selected.length >= gr.required);
    const filled = [...this.groups.values()].filter(gr => gr.selected.length >= gr.required).length;
    const wasDisabled = this.ctaEl?.disabled ?? true;

    if (this.ctaEl) {
      this.ctaEl.disabled = !complete;
      this.ctaEl.setAttribute("aria-disabled", String(!complete));
      if (complete && wasDisabled) {
        this.ctaEl.classList.add("bundle-builder__add-btn--ready");
        this.ctaEl.addEventListener("animationend", () => {
          this.ctaEl.classList.remove("bundle-builder__add-btn--ready");
        }, { once: true });
      }
    }

    if (this.hintEl) {
      if (complete) {
        this.hintEl.textContent = "✔ " + (this.hintEl.dataset.msgReady || "Klar til å legge til!");
        this.hintEl.className = "bundle-builder__hint bundle-builder__hint--ready";
      } else {
        this.hintEl.textContent = filled + " av " + this.totalGroups + " kategorier valgt";
        this.hintEl.className = "bundle-builder__hint";
      }
    }
  }

  async addToCart() {
    if (this.ctaEl?.disabled) return;
    const items = [];
    this.groups.forEach(g => g.selected.forEach(s => items.push({ id: parseInt(s.variant, 10), quantity: 1 })));
    if (!items.length) return;

    const orig = this.ctaEl.textContent;
    this.ctaEl.disabled = true;
    this.ctaEl.textContent = this.el.dataset.adding || "Adding…";
    if (this.errEl) this.errEl.hidden = true;

    const root = window.Shopify?.routes?.root ?? "/";
    try {
      const res = await fetch(root + "cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items })
      });
      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        throw new Error(data.description || "Error");
      }
      const code = this.el.dataset.discountCode;
      window.location.href = code ? root + "cart?discount=" + encodeURIComponent(code) : root + "cart";
    } catch {
      if (this.errEl) {
        this.errEl.textContent = this.el.dataset.error || "Could not add to cart. Please try again.";
        this.errEl.hidden = false;
      }
      this.ctaEl.disabled = false;
      this.ctaEl.textContent = orig;
    }
  }

  money(cents) {
    try {
      return new Intl.NumberFormat(undefined, {
        style: "currency",
        currency: this.currency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(cents / 100);
    } catch {
      return Math.round(cents / 100) + " " + this.currency;
    }
  }
}

document.querySelectorAll(".bundle-builder").forEach(el => new BundleBuilder(el));

  } catch(e) { console.error(e); }
})();
})();
